module.exports = __webpack_public_path__ + "img/Editare_profil.77497f8b.png";